export const sendMessageHelperTexts = ["Evi ne zaman görebilirim?", "Pazarlık payı var mı?"];
